'use client';
import { deleteUser } from 'firebase/auth';
import { useContext } from 'react';

import { isActiveToken } from '~/src/services/users';
import { RootContext } from '~/store';

export type LoggedInState = 'loggedIn' | 'unlogIn' | 'loading';

export type UseUser = () => {
  isReadyToFetchArc: boolean;
  deleteFirebaseUser: () => Promise<void>;
};

export const useUser: UseUser = () => {
  const { token, user, loggedInState } = useContext(RootContext);

  const isReadyToFetchArc = user
    ? isActiveToken(token) && loggedInState !== 'loading'
    : true;

  const deleteFirebaseUser = async () => {
    if (user == null) return;

    try {
      await deleteUser(user);
    } catch (e) {
      console.error(e);
      throw e;
    }
  };

  return {
    isReadyToFetchArc,
    deleteFirebaseUser,
  };
};
